export const LOADING_ANIMATION_TEST_ID = 'loading-animation'
export const ICON_TEST_ID = 'button-icon'
